import { useEffect, useState } from 'react'

import './style.scss';
import { useAppDispatch } from '../../redux/hooks';
import { UserPost, UserPostComment } from '../../types/posts';
import AppUserPost from '../app_userPost/AppUserPost';
import { PAGE_URLS } from '../../constants/hrefLinks';
import { setCommentPost, setUserPosts } from '../../redux/reducers/postSlice';
import { commentConnector } from '../../server/connector/commentConnector';
import { userStateData } from '../../data/userStateData';
import { communityStateData } from '../../data/communityStateData';
import AppUserComment from '../app_userComment/AppUserComment';

interface AppCommentProps {
	postData: UserPost
}

function AppComment({postData}: AppCommentProps) {

	const dispatch = useAppDispatch()

	const [loadingComments, setLoadingComments] = useState<boolean>(false)

	const [makingComment, setMakingComment] = useState<boolean>(false) // true during posting to server
	
	const [postComment, setPostComment] = useState<string>('')
	const [existingComments, setExistingComments] = useState<UserPostComment[]>([])

	useEffect(() => {
		loadComments()
	}, [postData])

	const loadComments = () => {
		setLoadingComments(true)
		setExistingComments([])
		commentConnector.getCommentsForPostRequest(postData.postId).then((successResponse) => {
			setExistingComments(communityStateData.loadedComments)
			setLoadingComments(false)
		})
	}

	const backButtonClickHandler = () => {
		if (makingComment !== true) {
			dispatch(setCommentPost(undefined))
		}
	}

	const postButtonClickHandler = () => {
		setMakingComment(true)
		if (commentConnector.requestInProgress === false) {
			commentConnector.performCreateCommentRequest(
				userStateData.getId(),
				postData.postId,
				postComment
			).then((successResponse) => {
				setMakingComment(false)
				communityStateData.increasePostCommentCount(postData.postId)
				dispatch(setUserPosts(communityStateData.userPosts))
				dispatch(setCommentPost(undefined))
			})
		}
	}
	
	return (
		<>
			<div className='section-wrap app-new-comment-wrap'>
				<div className='app-new-comment-header-wrap'>
					<img
						src={'/imgs/icons/instructor/icon-instructor-header-back-button.svg'}
						className='app-new-comment-back-button'
						alt='Back Button'
						onClick={() => {
							backButtonClickHandler()
						}}
					/>
					<button
						className='app-new-comment-post-button'
						disabled={postComment.length < 2 || makingComment || loadingComments}
						onClick={() => postButtonClickHandler()}
					>Post</button>
				</div>
				<div className='app-new-comment-post-wrap'>
					<AppUserPost data={postData} disableInteraction={true} />
				</div>
				<div className='app-new-comment-existing-comments-wrap'>
					{existingComments.map((commentData: UserPostComment, index: number) => 
						<AppUserComment data={commentData} key={`comment${index}`} /> 
					)}
				</div>
				<div className='app-new-comment-instruction-wrap'>
					Replying to <a
						className='app-new-comment-instruction-name'
						href={`${PAGE_URLS.APP_PROFILE_USER}?id=${postData.sourceUserId}`}
						aria-label={'Link to post user profile'}
					>@{postData.sourceName.replace(' ', '.').toLowerCase()}</a>
				</div>
				<textarea 
					className='app-new-comment-message-input'
					value={postComment}
					placeholder='What do you want to say'
					disabled={makingComment || loadingComments}
					onChange={(evt) => {
						setPostComment(evt.target.value ? evt.target.value.substring(0, 256) : evt.target.value)
					}}
				/>
			</div>
		</>
	)
}

export default AppComment
